import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  hasUndo: false,
  hasRedo: false,
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.UPDATE_UNDO_REDO:
      return {
        ...state,
        hasUndo: action.hasUndo,
        hasRedo: action.hasRedo,
      };
    default:
      return state;
  }
}